import TenantFilter from 'types/filters/tenantFilter';
import { Tenant } from 'types/tenant';
import { PaginationResult } from 'types/paginationResult';
import axios from 'utils/axios';

export default class TenantService {
    async getTenantsCount(): Promise<number> {
        try {
            const result = await axios.post<number>(`/GetTenantsCount`);
            return result.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch tenants count');
        }
    }

    async getTenants(tenantFilter: TenantFilter): Promise<PaginationResult<Tenant>> {
        try {
            const body = {
                page: tenantFilter.page,
                recordsPerPage: tenantFilter.recordsPerPage,
                searchString: tenantFilter.searchString,
                orderBy: tenantFilter.orderBy,
                orderAscending: tenantFilter.orderAscending
            };
            const result = await axios.post<PaginationResult<Tenant>>(`/GetTenants`, body);
            return result.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch tenant list');
        }
    }

    async addTenant(tenant: Tenant): Promise<boolean> {
        try {
            const response = await axios.post(`/AddTenant`, {
                name: tenant.name
            });
            if (response.status >= 200 && response.status < 300) {
                return true;
            }
            return false;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to add tenant');
        }
    }

    async editTenant(tenant: Tenant): Promise<boolean> {
        try {
            const response = await axios.post(`/EditTenant`, tenant);
            if (response.status >= 200 && response.status < 300) {
                return true;
            }
            return false;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to edit tenant');
        }
    }

    async deleteTenant(tenantId: string): Promise<boolean> {
        try {
            const response = await axios.post(`/DeleteTenant`, tenantId);
            if (response.status >= 200 && response.status < 300) {
                return true;
            }
            return false;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to delete tenant');
        }
    }
}
